import {RouteNameEnum} from "@/v2/enumerate/route";

const message = [{
	path: "message",
	name: RouteNameEnum.GLORY_MESSAGE,
	meta: {
		permission: 65001,
		breadcrumb: [{
			key: "glory.message.index",
			value: null
		}]
	},
	component: () => import("@/page/content/glory/message/index.vue"),
}];

export default message;
